import { TrialHeaderQueryHookResult, useTrialInfoQuery } from "@generated/graphql";
import CircularLoading from "components/CircularLoading";
import useIsCreate from "hooks/useIsCreate";
import useGetCompetencyMapOptions from "pages/Testing/view/hooks/useGetCompetencyMapOptions";
import useGetScenarioOptions from "pages/Testing/view/hooks/useGetScenarioOptions";
import { useParams } from "react-router-dom";
import InfoTabContent from "./Content";

interface InfoTabProps {
  refetchTrialHeader: TrialHeaderQueryHookResult["refetch"];
}

const InfoTab = ({ refetchTrialHeader }: InfoTabProps) => {
  const isCreate = useIsCreate();
  const { id } = useParams();

  const { data, loading: trialInfoLoading } = useTrialInfoQuery({
    variables: {
      trialId: id!,
    },
    skip: !id,
  });
  const trial = data?.trial;

  const { competencyMapsOptions, loading: competencyMapsLoading } = useGetCompetencyMapOptions();
  const { scenariosOptions, loading: scenariosLoading } = useGetScenarioOptions();

  const loading = trialInfoLoading || (isCreate && (competencyMapsLoading || scenariosLoading));

  if (loading || (!trial && !isCreate)) return <CircularLoading />;

  return (
    <InfoTabContent
      trial={trial}
      trialInfoLoading={loading}
      competencyMapsOptions={competencyMapsOptions}
      competencyMapsLoading={competencyMapsLoading}
      scenariosOptions={scenariosOptions}
      scenariosLoading={scenariosLoading}
      refetchTrialHeader={refetchTrialHeader}
    />
  );
};

export default InfoTab;
